import { render, staticRenderFns } from "./PersonalityTest.vue?vue&type=template&id=4369072a&"
import script from "./PersonalityTest.vue?vue&type=script&lang=js&"
export * from "./PersonalityTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports